export default __webpack_public_path__ + "d5d23dc33dca0f2776e1da88052d9d30.svg";